import { render, staticRenderFns } from "./AiVoiceWriteButton.vue?vue&type=template&id=2216bb38"
import script from "./AiVoiceWriteButton.vue?vue&type=script&lang=js"
export * from "./AiVoiceWriteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports